export default __webpack_public_path__ + "static/media/nft-6.56b57e13.png";